import {
  Page,
  useModals,
  Button,
  ButtonLink,
  Card,
  FontAwesomeIcon,
  Stack,
  Title,
} from "@skailer-com/uikit";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { CareerSiteEditModal } from "@/pages/settings/career-sites/widgets/CareerSiteEditModal.tsx";
import { useCareerSiteGetAll } from "@/queries/recruit/use-career-sites.query.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";

export function CareerSitesIndex() {
  const { t } = useTranslation();
  const { openModal } = useModals();
  const { data: sites, isLoading } = useCareerSiteGetAll();
  useTitle(t("ats:career_sites"), t("common:settings"));

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.careerSites.viewed);
  });

  return (
    <Page>
      <Page.Header title={t("ats:career_sites")} showBack={true} />
      <Page.Content>
        <Stack className={"px-16"}>
          <Title
            paddingTop={true}
            header={t("ats:career_sites")}
            caption={t("ats:publish_jobs_to_career_pages")}
            paddingBottom={true}
            size={"lg"}
          />

          <Stack
            direction={"horizontal"}
            gap={"md"}
            className={"grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6"}
          >
            {isLoading ? (
              <Card isLoading={true} />
            ) : (
              <>
                {sites?.map((site) => (
                  <Card
                    header={site.title}
                    key={site.id}
                    buttonsSlot={
                      <>
                        <Button
                          onClick={() => {
                            openModal(CareerSiteEditModal, {
                              careerSiteId: site.id,
                            });
                          }}
                        >
                          {t("common:edit")}
                        </Button>
                        <ButtonLink
                          variant={"secondary"}
                          href={`https://careers.${import.meta.env.VITE_DOMAIN}/${site.slug}`}
                          target={"_blank"}
                          rightIcon={
                            <FontAwesomeIcon icon={"fa-light fa-arrow-up-right-from-square"} />
                          }
                        >
                          {t("common:view")}
                        </ButtonLink>
                      </>
                    }
                  />
                ))}
                <Card
                  icon={"fa-plus"}
                  header={t("ats:create_page")}
                  variant={"action"}
                  onClick={() => {
                    openModal(CareerSiteEditModal);
                  }}
                />
              </>
            )}
          </Stack>
        </Stack>
      </Page.Content>
    </Page>
  );
}
